import React, { useEffect, useRef } from 'react';
import ProductCard from '../components/ProductCard';
import Have5 from '../assets/Have5.jpg';
import Chappies from '../assets/Chappies.jpeg';
import Halls from '../assets/Halls.jpeg';
import Nik from '../assets/NikNaks.jpeg';
import Rago from '../assets/Rago.jpg';
import Toros from '../assets/Toros.jpeg';
import SP from '../assets/SP.jpg';
import Eclairs from '../assets/Eclairs.jpeg';
import Yogueta from '../assets/Yogueta.jpeg';


const Home = () => {
  const heroRef = useRef(null);

  // Idle drift + scroll parallax on bubbles
  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;

    const shapes = [...hero.querySelectorAll('.shape')];
    const driftAmp = [55, 38, 46];
    const driftSpd = [0.00042, 0.00031, 0.00037];
    const driftPhs = [0, Math.PI * 0.7, Math.PI * 1.4];

    let raf;
    const cur = shapes.map(() => ({ x: 0, y: 0 }));
    const lerp = (a, b, t) => a + (b - a) * t;

    const tick = (ts) => {
      shapes.forEach((shape, i) => {
        const scrollOff = -(window.pageYOffset * (i + 1) * 0.4);
        const targetX = Math.sin(ts * driftSpd[i] + driftPhs[i]) * driftAmp[i];
        const targetY = Math.cos(ts * driftSpd[i] * 0.65 + driftPhs[i]) * driftAmp[i] * 0.7;

        cur[i].x = lerp(cur[i].x, targetX, 0.025);
        cur[i].y = lerp(cur[i].y, targetY, 0.025);

        shape.style.transform = `translate(${cur[i].x}px, ${scrollOff + cur[i].y}px)`;
      });

      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);

    return () => cancelAnimationFrame(raf);
  }, []);

  const products = [
    {
      icon: Nik,
      name: 'Nik Naks',
     
    },
    {
      icon: Chappies,
      name: 'Chappies',
    },
    {
      icon: Rago,
      name: 'Rago',
    },
    {
      icon: Halls,
      name: 'Halls',
    },
    {
      icon: Toros,
      name: 'Assorted Gummies',
    },
    {
      icon: Eclairs,
      name: 'Cadbury Eclairs',
    },
    {
      icon: SP,
      name: 'Star Pops',
    },
    {
      icon: Yogueta,
      name: 'Assorted Lollipops',
    },
    {
      icon: Have5,
      name: 'Assorted Biscuits',
    }
  ];

  const scrollToProducts = (e) => {
    e.preventDefault();
    const productsSection = document.getElementById('products');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <header className="hero" ref={heroRef}>
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="glitch" data-text="Sweet & Snack World">
              Sweet & Snack World
            </span>
          </h1>
          <p className="hero-subtitle">Experience the Future of Sweetness</p>
          <a href="#products" className="cta-button" onClick={scrollToProducts}>
            Explore Our Collection
          </a>
        </div>
        <div className="hero-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </header>

      <section id="products" className="products-section">
        <div className="container">
          <h2 className="section-title">Featured Treats</h2>
          <p className="section-subtitle">From time-honored classics to innovative new flavors, discover our carefully curated collection of sweets and snacks. For more visual delights, visit our store in Groblersdal!</p>
          
          <div className="products-grid">
            {products.map((product, index) => (
              <ProductCard
                key={index}
                icon={product.icon}
                name={product.name}
                description={product.description}
                tag={product.tag}
              />
            ))}
          </div>
        </div>
      </section>

      
    </>
  );
};

export default Home;
